<template>
  <v-container
    v-if="selectedSubmission !== {}"
    fluid
    class="pa-0 form-container"
  >
    <v-layout justify-space-between>
      <v-navigation-drawer
        permanent
        width="320"
        v-if="selectedSubmissionStats && selectedSubmissionStats.summary"
      >
        <div style="height: 70px; width: 100%"></div>
        <div v-if="!$_isPublicForm">
          <!-- <v-layout>
            <v-col>
              <v-row align="center" justify="center" class="subtitle-1"
                >Turn time</v-row
              >
              <v-row align="center" justify="center" class="headline"
                >{{ selectedSubmissionStats.summary.turn_time }} hours</v-row
              >
            </v-col>
          </v-layout>

          <v-divider /> -->

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 text-center"
                >Task remaining</v-list-item-title
              >
              <v-list-item-subtitle class="subtitle-2 text-center">
                <span class="title">
                  {{ selectedSubmissionStats.summary.remaining_questions || 0 }}
                </span>
                of
                <span class="title">
                  {{ selectedSubmissionStats.summary.questions_total }}
                </span>
                <v-progress-linear
                  color="primary"
                  rounded
                  :value="progressbarValue"
                />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider />

          <v-layout>
            <v-col class="ma-2">
              <v-row align="center" justify="center">
                <div class="caption text-center">Not Started</div>
              </v-row>
              <v-row align="center" justify="center">
                <div class="subtitle-2 text-center">
                  {{ selectedSubmissionStats.summary.sections_not_started }}
                </div>
              </v-row>
            </v-col>

            <v-col class="ma-2">
              <v-row align="center" justify="center">
                <div class="caption text-center">In Progres</div>
              </v-row>
              <v-row align="center" justify="center">
                <div class="subtitle-2 text-center">
                  {{ selectedSubmissionStats.summary.sections_in_progress }}
                </div>
              </v-row>
            </v-col>

            <v-col class="ma-2">
              <v-row align="center" justify="center">
                <div class="caption text-center">Completed</div>
              </v-row>
              <v-row align="center" justify="center">
                <div class="subtitle-2 text-center">
                  {{ selectedSubmissionStats.summary.sections_completed }}
                </div>
              </v-row>
            </v-col>
          </v-layout>

          <v-divider />
        </div>

        <v-list-item-group
          mandatory
          class="px-3 pt-5"
          v-if="allSections.length"
          v-model="activeSubmissionSection"
        >
          <v-list-item
            v-for="section in allSections"
            :key="section.id"
            link
            class="px-2 py-3"
            dense
            @click="changeSection(section)"
          >
            <!-- :disabled="!sectionIndexes.includes(i) && section.type === 'normal'" -->
            <v-list-item-content>
              <v-list-item-title>
                {{ section.title }}
                <span
                  class="grey--text"
                  v-if="!$_isPublicForm && selectedSubmissionStats !== {}"
                >
                  &nbsp;({{
                    selectedSubmissionStats.form_status.find(
                      el => el.section_id === section.id
                    ).pending || 0
                  }})
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-navigation-drawer>

      <v-layout class="px-2">
        <v-layout class="px-2">
          <v-container class="px-0">
            <div class="pr-5">
              <!-- First row -->
              <v-layout class="px-3">
                <v-row
                  align="center"
                  justify="center"
                  style="border-bottom: 1px solid #9e9e9e"
                  v-if="Object.keys(this.selectedSubmissionDetails).length"
                >
                  <v-col v-for="header in submissionHeaders" :key="header.name">
                    <v-row>
                      <span class="subtitle-1">{{ header.name || 'N/A' }}</span>
                    </v-row>
                    <v-row>
                      <span class="subtitle-2">{{ header.data || 'N/A' }}</span>
                    </v-row>
                  </v-col>
                  <v-btn icon class="mb-6" align="end">
                    <v-icon @click="closeSubmission" color="primary"
                      >cancel</v-icon
                    >
                  </v-btn>
                </v-row>
              </v-layout>
              <!-- Second row -->
              <v-layout v-if="!formSubmit">
                <v-row
                  align="center"
                  style="border-bottom: 1px solid #9e9e9e"
                  class="py-3 ml-0"
                >
                  <v-col> </v-col>
                  <v-col class="text-right">
                    <v-btn
                      color="primary"
                      :loading="holdButtonLoading"
                      @click="openHoldModal"
                    >
                      {{ isSubmissionOnHold ? 'Unhold' : 'Hold' }} this form
                    </v-btn>
                  </v-col>
                </v-row>
              </v-layout>

              <forms-engine-component
                v-if="selectedSubmissionSection.type === 'normal'"
                ref="formEngine"
                :form-id="selectedForm.id"
                :auth-token="authToken"
                rendering-type="section"
                :section-id="selectedSection.id"
                :client-token="clientToken"
                :submission-token="submissionToken"
                :api-url="this.apiUrl"
                basic-datepicker="false"
                is-guest="false"
                :pubnub-subscribe-key="subscribekey"
                :pubnub-publish-key="publishkey"
                :pubnub-uuid="pubnubuuid"
                @requestingServer="e => showSpinner(e)"
                @formMessage="e => this.showFormMessage(e)"
                @formEngineLoaded="e => this.setFormEngineStatus(e)"
              >
              </forms-engine-component>
              <layout-summary
                v-else-if="selectedSubmissionSection.type === 'summary'"
                :selectedSection="selectedSubmissionSection"
                :formId="selectedForm.id"
                :key="selectedSubmissionSection.id"
                :refAnwers="refAnwers"
                ref="layoutSummary"
              />
              <div v-if="isLastSection" class="mt-4 px-4">
                <p
                  v-if="
                    selectedSubmission.submission_status === 'approved' &&
                      !$_isPublicForm
                  "
                >
                  This submission is approved.
                </p>
                <p
                  v-else-if="
                    selectedSubmission.submission_status === 'rejected' &&
                      !$_isPublicForm
                  "
                >
                  This submission is rejected.
                </p>
                <p
                  v-else-if="
                    selectedSubmission.submission_status === 'submitted' &&
                      !$_isPublicForm
                  "
                >
                  This submission is submitted.
                </p>
                <p
                  v-else-if="
                    selectedSubmission.submission_status === 'hold' &&
                      !$_isPublicForm
                  "
                >
                  This submission is on hold.
                </p>
              </div>
              <v-layout
                justify-space-between
                v-if="isFormEngineLoaded"
                class="mt-2"
              >
                <span>
                  <v-btn
                    v-if="
                      isLastSection &&
                        (selectedSubmission.submission_status === 'submitted' ||
                          selectedSubmission.submission_status === 'approved' ||
                          selectedSubmission.submission_status === 'rejected')
                    "
                    depressed
                    :disabled="
                      !permissions.app_permissions.submissions.reject ||
                        selectedSubmission.submission_status === 'approved' ||
                        selectedSubmission.submission_status === 'rejected' ||
                        selectedSubmission.submission_status === 'hold' ||
                        $_isPublicForm
                    "
                    @click="rejectSubmission"
                    >Reject</v-btn
                  >
                  <v-btn
                    v-else-if="isFirstSection"
                    depressed
                    @click="closeSubmission"
                    >Dashboard</v-btn
                  >
                  <v-btn v-else depressed @click="previousSection"
                    >Previous</v-btn
                  >
                </span>
                <span v-if="isLastSection" color="">
                  <v-btn
                    v-if="
                      permissions.app_permissions.submissions.approve ||
                        selectedSubmission.submission_status === 'approved' ||
                        selectedSubmission.submission_status === 'rejected' ||
                        selectedSubmission.submission_status === 'submitted'
                    "
                    @click="approveSubmission"
                    depressed
                    :disabled="
                      !permissions.app_permissions.submissions.approve ||
                        selectedSubmission.submission_status === 'approved' ||
                        selectedSubmission.submission_status === 'rejected' ||
                        selectedSubmission.submission_status === 'hold' ||
                        $_isPublicForm
                    "
                  >
                    Approve
                  </v-btn>
                  <v-btn
                    v-else
                    @click="submit"
                    depressed
                    :disabled="
                      selectedSubmission.submission_status === 'hold' ||
                        !permissions.app_permissions.submissions.submit
                    "
                    >Submit</v-btn
                  >
                </span>
                <v-btn v-else depressed @click="nextSection">Next</v-btn>
              </v-layout>
            </div>
          </v-container>
        </v-layout>
      </v-layout>
    </v-layout>

    <!-- Hold dialog -->
    <v-dialog
      v-model="holdSubmissionModal"
      max-width="500px"
      v-if="!$_isPublicForm"
    >
      <v-card>
        <v-card-title>
          Reason for {{ isSubmissionOnHold ? 'Unhold' : 'Hold' }}ing this form
        </v-card-title>
        <v-card-text>
          <v-select
            v-if="
              selectedForm.attributes &&
                selectedForm.attributes.onhold_reasons.length
            "
            :items="selectedForm.attributes.onhold_reasons"
            label="On hold reason"
            v-model="submissionOnHoldReasonsValue"
          />
          <v-textarea
            v-else
            label="On hold reason"
            v-model="submissionOnHoldReasonsValue"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="submissionOnHoldReasonsValue === ''"
            :loading="loading"
            @click="updateSubmissionHoldStatus(true)"
            class="ma-3"
            >{{ isSubmissionOnHold ? 'Unhold' : 'Hold' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <approve-modal
      ref="approveModal"
      :isSignatureRequired="isSignatureRequired"
      :signatureQuestion="signatureQuestion"
      @approve-submission="confirmRejectApprove"
    >
    </approve-modal>
    <reject-modal
      ref="rejectModal"
      :isSignatureRequired="isSignatureRequired"
      :signatureQuestion="signatureQuestion"
      @reject-submission="confirmRejectApprove"
    >
    </reject-modal>
    <submit-modal
      ref="submitModal"
      :isSignatureRequired="isSignatureRequired"
      :signatureQuestion="signatureQuestion"
      @submit-submission="submitSubmission"
    >
    </submit-modal>
  </v-container>
</template>

<script>
import LayoutSummary from '@/components/form/formLayout/LayoutSummary'
import ApproveModal from '@/components/modals/ApproveModal'
import RejectModal from '@/components/modals/RejectModal'
import SubmitModal from '@/components/modals/SubmitModal'
import FormPublicApi from '@/api/formPublic/formPublic'

import { mapMutations, mapActions, mapGetters } from 'vuex'
import uiHelper from '@/helpers/ui'
import { EventBus } from '@/eventBus.js'

export default {
  components: {
    LayoutSummary,
    ApproveModal,
    RejectModal,
    SubmitModal
  },

  data() {
    return {
      showAssigned: false,
      holdSubmissionModal: false,
      success: false,
      activeSubmissionSection: 0,
      submissionOnHoldReasonsValue: '',
      loading: false,
      holdButtonLoading: false,
      refAnwers: {},
      allFieldsAnswered: false,
      isFormEngineLoaded: false,
      lastRoute: '',
      showSummary: false
    }
  },

  computed: {
    ...mapGetters({
      selectedForm: 'form/selectedForm',
      selectedSubmission: 'form/selectedSubmission',
      selectedSubmissionStats: 'form/selectedSubmissionStats',
      selectedSubmissionSection: 'form/selectedSubmissionSection',
      selectedSubmissionDetails: 'form/selectedSubmissionDetails',
      permissions: 'user/userPermissions',
      submissionToken: 'form/selectedSubmissionToken',
      clientToken: 'user/clientToken',
      authToken: 'auth/authToken'
    }),

    allSections() {
      if (this.selectedSubmission?.sections?.length) {
        const allSections = this.selectedSubmission.sections
        if (allSections[0].title === 'Create New') {
          return allSections.slice(1)
        }
        return allSections
      }

      return []
    },

    selectedSection: {
      get() {
        if (!this.showAssigned) {
          return { ...this.selectedSubmissionSection }
        } else {
          let selectedSection = { ...this.selectedSubmissionSection }
          let questions = this.selectedSubmissionSection.questions.filter(
            question => question.can_answer
          )
          selectedSection.questions = questions
          return selectedSection
        }
      },
      set(val) {
        return val
      }
    },

    selectedSectionIndex() {
      return this.allSections.findIndex(
        item => item.id === this.selectedSubmissionSection.id
      )
    },

    isSelectedSubmissionOnHold() {
      if (this.selectedSubmission.submission_status === 'hold') {
        return true
      }

      return false
    },

    progressbarValue() {
      return (
        (this.selectedSubmissionStats?.summary?.questions_answered /
          this.selectedSubmissionStats?.summary?.questions_total) *
        100
      )
    },

    submissionHeaders() {
      return this.selectedSubmissionDetails.data
    },

    isSubmissionOnHold: {
      get() {
        return this.isSelectedSubmissionOnHold
      },
      set(value) {
        this.setSelectedSubmissionOnHoldStatus(value)
      }
    },
    formSubmit() {
      if (
        this.selectedSubmission?.submission_status === 'submitted' ||
        this.selectedSubmission?.submission_status === 'completed' ||
        this.selectedSubmission?.submission_status === 'approved' ||
        this.selectedSubmission?.submission_status === 'rejected'
      ) {
        return true
      }
      return false
    },

    deletePermission() {
      if (
        this.permissions.app_permissions.submissions.hasOwnProperty('delete')
      ) {
        return this.permissions.app_permissions.submissions.delete
      }
      return false
    },

    isFirstSection() {
      if (this.selectedSectionIndex === 0) return true
      return false
    },

    isLastSection() {
      const totalSections = this.allSections.length
      if (this.selectedSectionIndex + 1 === totalSections) return true
      return false
    },
    apiUrl() {
      return process.env.VUE_APP_FORMS_URL
    },
    subscribekey() {
      return process.env.VUE_APP_PUBNUB_SUBSCRIBE_KEY
    },
    publishkey() {
      return process.env.VUE_APP_PUBNUB_PUBLISH_KEY
    },
    pubnubuuid() {
      return process.env.VUE_APP_PUBNUB_UUID
    },
    isSignatureRequired() {
      let required = false
      let questions = this.selectedSubmissionSection.questions
      if (questions) {
        questions.forEach(question => {
          let signature = question.options.find(
            option => option.type === 'signature'
          )
          if (signature) required = true
        })
      }
      return required
    },
    signatureQuestion() {
      let questions = this.selectedSubmissionSection?.questions
      let question = {}
      if (questions) {
        let question = this.selectedSubmissionSection?.questions.find(
          question =>
            question.options.some(option => option.type === 'signature')
        )
        if (question) return question
      }
      return question
    }
  },

  async created() {
    uiHelper.progressBarStatus(true)
    this.clearAllSubmissions()
    this.setSelectedSubmissionToken(this.$route.params.id)
    try {
      await this.getFormDetails(this.selectedFormId)
      this.setSelectedSubmissionSection(this.allSections[0])
      await this.getSubmissionStats()

      this.setSummarySection()
    } catch (error) {
      uiHelper.progressBarStatus(false)
      if (error.response?.data?.msg) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
    }
  },

  async mounted() {
    EventBus.$on('update-required', async () => {
      await this.getResponsesBySection()
    })
  },

  destroyed() {
    this.resetSelectedForm()
  },

  watch: {},

  methods: {
    ...mapMutations({
      setSelectedSubmissionToken: 'form/setSelectedSubmissionToken',
      setSelectedSubmission: 'form/setSelectedSubmission',
      setSelectedSubmissionSection: 'form/setSelectedSubmissionSection',
      setSelectedSubmissionOnHoldStatus:
        'form/setSelectedSubmissionOnHoldStatus',
      resetSelectedForm: 'form/resetSelectedForm',
      clearAllSubmissions: 'form/clearAllSubmissions'
    }),

    ...mapActions({
      getFormDetails: 'form/getSubmissionDetails',
      getSubmissionStats: 'form/getSubmissionStats',
      getSectionResponses: 'form/getSectionResponses',
      updateHoldStatus: 'form/updateSubmissionHoldStatus',
      cancelSubmission: 'form/cancelSubmission',
      va_approveSubmission: 'form/approveSubmission'
    }),

    setSummarySection() {
      let showSummaryPage = this.selectedSubmission.settings.show_summary_page

      let hasSummarySection =
        this.allSections[this.allSections.length - 1].type === 'summary'
          ? true
          : false

      if (showSummaryPage) {
        if (hasSummarySection) return
        else {
          let newSubmission = { ...this.selectedSubmission }
          let newSummarySection = {
            form_id: this.selectedSubmissionSection.form_id,
            id: 'custom-summary',
            type: 'summary',
            questions: [],
            title: 'Summary'
          }
          newSubmission.sections.push(newSummarySection)
          this.setSelectedSubmission(newSubmission)
        }
      } else {
        if (!hasSummarySection) return
        else {
          let newSubmission = { ...this.selectedSubmission }
          newSubmission.sections.pop()
          this.setSelectedSubmission(newSubmission)
        }
      }
    },

    changeSectionActiveClass(value) {
      this.activeSubmissionSection = value
    },

    openHoldModal() {
      if (this.isSubmissionOnHold) {
        this.holdButtonLoading = true

        this.updateSubmissionHoldStatus(false)
      } else {
        this.holdSubmissionModal = true
      }
    },

    async updateSubmissionHoldStatus(value) {
      this.loading = true
      let data = {
        is_onhold: value,
        onhold_reason: this.submissionOnHoldReasonsValue
      }
      await this.updateHoldStatus({
        formId: this.selectedForm.id,
        data
      })
      this.loading = false
      this.holdSubmissionModal = false
      this.$router.push({ name: 'Dashboard' })
    },

    async changeSection(section) {
      uiHelper.progressBarStatus(true)

      this.setSelectedSubmissionSection(section)

      this.changeSectionActiveClass(this.selectedSectionIndex)

      try {
        await this.getSubmissionStats()
      } catch (error) {
        uiHelper.progressBarStatus(false)
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
      this.$_scrollToTop()
      // uiHelper.progressBarStatus(false)
    },

    async getResponsesBySection() {
      try {
        let payload = await this.getSectionResponses({
          isPublicForm: this.$_isPublicForm
        })
        this.refAnwers = payload
      } catch (error) {
        throw error
      }
    },

    async update() {
      await this.getSectionResponses()
    },

    submit() {
      if (this.selectedSubmissionSection.type === 'normal') {
        try {
          this.$refs.formEngine._submitForm()
        } catch (error) {
          throw error
        }
      } else if (this.selectedSubmissionSection.type === 'summary') {
        if (this.isSignatureRequired) {
          this.$refs.submitModal.openSubmitModal()
        } else this.submitSubmission()
      }
    },

    async submitSubmission() {
      this.$refs.submitModal.buttonProgress = true
      this.$refs.submitModal.errors = ''
      uiHelper.progressBarStatus(true)
      try {
        uiHelper.progressBarStatus(false)

        const response = await FormPublicApi.submitForm({
          form_id: this.selectedSubmissionSection.form_id
        })
        uiHelper.showSnackbarMessage(response.data.msg)
        if (this.selectedSubmission.settings.show_thankyou_page) {
          this.$emit('show-thankyou-page')
        }
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      } finally {
        uiHelper.progressBarStatus(false)
      }
      this.$refs.submitModal.buttonProgress = false
      this.$refs.submitModal.modal = false
    },

    approveSubmission() {
      if (this.isLastSection) {
        this.$refs.approveModal.openApproveModal()
      } else {
        uiHelper.showSnackbarMessage('Something went wrong', 'error')
      }
    },

    rejectSubmission() {
      if (this.isLastSection) {
        this.$refs.rejectModal.openRejectModal()
      } else {
        uiHelper.showSnackbarMessage('Something went wrong', 'error')
      }
    },

    showSpinner(e) {
      if (e.detail) uiHelper.progressBarStatus(true)
      else if (!e.detail) uiHelper.progressBarStatus(false)
    },

    showFormMessage(e) {
      uiHelper.showSnackbarMessage(e.detail.message, e.detail.type)
    },

    setFormEngineStatus(e) {
      this.isFormEngineLoaded = e.detail
    },

    previousSection() {
      const _previousSection = this.allSections[this.selectedSectionIndex - 1]
      this.changeSection(_previousSection)
    },
    async nextSection() {
      if (await this.$refs.formEngine._validate()) {
        const _nextSection = this.allSections[this.selectedSectionIndex + 1]
        this.changeSection(_nextSection)
      } else {
        uiHelper.showSnackbarMessage('Please fill required fields', 'error')
      }
    },
    closeSubmission() {
      if (!this.$_isPublicForm) {
        this.$router.push({ name: 'Dashboard' })
      } else if (this.$_isPublicForm) {
        this.$router.push({ name: 'Public Forms' })
      } else if (this.lastRoute === 'Archive') {
        this.$router.push({ name: 'Archive' })
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    },
    async confirmRejectApprove(data) {
      let ref = data.confirmType
        ? this.$refs.approveModal
        : this.$refs.rejectModal
      ref.buttonProgress = true
      const payload = {
        is_approved: data.confirmType,
        approved_by: String(this.$_userId),
        approved_by_signature: data.signature.url,
        rejected_reasons: data.selectedReason
      }
      try {
        const response = await this.va_approveSubmission({
          formId: this.selectedSubmissionSection.form_id,
          data: payload
        })
        uiHelper.showSnackbarMessage(response.data.msg)
        this.$router.push({ name: 'Dashboard' })
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
      ref.modal = false
      ref.buttonProgress = false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.lastRoute = from.name
    })
  }
}
</script>

<style scoped>
.form-container .v-navigation-drawer {
  position: fixed;
  left: 60px;
  top: 65px;
}
.form-container .v-navigation-drawer + .layout {
  margin-left: 320px;
}
</style>
